import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { Formik } from 'formik'
import { customerMergeSchema } from '../../../lib/schemas'
import * as mergeActionsCreators from '../../../redux/css-admin/merge/mergeManager'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MergeLayout from './MergeLayout'

class MergeContainer extends Component {
  static propTypes = {
    fetchAndHandlePreviewMerge: PropTypes.func.isRequired,
    mergeAndHandleCustomers: PropTypes.func.isRequired,
  }

  enableValidation = props => {
    return (
      props.isSubmitting ||
      props.isValidating ||
      !props.isValid ||
      !props.touched
    )
  }

  enableSubmit = props => {
    return !props.previewMergeCustomerResults || props.dirty
  }

  handleSubmit = async (values, { setSubmitting }) => {
    const { activePrimaryId, activeDuplicateId } = values
    await this.props.mergeAndHandleCustomers({
      activePrimaryId,
      [activePrimaryId]: values[activePrimaryId],
      activeDuplicateId,
      [activeDuplicateId]: values[activeDuplicateId],
    })
    setSubmitting(false)
  }

  handleValidation = async (values, setSubmitting, resetForm) => {
    const { activePrimaryId, activeDuplicateId } = values
    setSubmitting(true)
    await this.props.fetchAndHandlePreviewMerge({
      activePrimaryId,
      [activePrimaryId]: values[activePrimaryId],
      activeDuplicateId,
      [activeDuplicateId]: values[activeDuplicateId],
    })
    setSubmitting(false)
    resetForm(values)
  }

  render() {
    return (
      <Formik
        initialValues={{
          activeDuplicateId: 'duplicateNSCustomerId',
          duplicateNSCustomerId: '',
          duplicateSecondstepId: '',
          activePrimaryId: 'primaryNSCustomerId',
          primaryNSCustomerId: '',
          primarySecondstepId: '',
          hasValidatedMerge: false,
        }}
        isInitialValid={false}
        onSubmit={this.handleSubmit}
        validationSchema={customerMergeSchema}
      >
        {formikProps => {
          return (
            <form onSubmit={formikProps.handleSubmit}>
              <MergeLayout
                {...this.props}
                {...formikProps}
                enableValidation={this.enableValidation}
                enableSubmit={this.enableSubmit}
                handleValidation={this.handleValidation}
              />
            </form>
          )
        }}
      </Formik>
    )
  }
}

const mapStateToProps = ({ mergeManager }) => {
  return {
    ...mergeManager,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...mergeActionsCreators,
    },
    dispatch,
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MergeContainer)



// WEBPACK FOOTER //
// ./src/containers/css-admin/merge/MergeContainer.js